<h2 mat-dialog-title>Check out</h2>

<mat-dialog-content>
  <div class="aco-stale" *ngIf="data.stale">
    <mat-icon>schedule</mat-icon>
    <div>
      You were still checked in from <strong>{{ start | date: 'EEEE d MMM, HH:mm' }}</strong>.
      Set the time you actually left — we have suggested one so the day is not over-counted.
    </div>
  </div>

  <div class="aco-row">
    <span class="aco-label">Checked in</span>
    <span class="aco-value">
      {{ start | date: 'HH:mm' }}
      <span class="aco-place" *ngIf="data.checkInPlace">· {{ data.checkInPlace }}</span>
    </span>
  </div>

  <div class="aco-row">
    <span class="aco-label">Checked out</span>
    <span class="aco-value aco-out">
      <input
        type="time"
        class="aco-time-input"
        [(ngModel)]="endTime"
        aria-label="Check-out time" />
      <span class="aco-place" *ngIf="!data.stale">
        <ng-container *ngIf="data.checkOutPlace$ | async as place; else locating">· {{ place }}</ng-container>
        <ng-template #locating>· locating…</ng-template>
      </span>
    </span>
  </div>

  <div class="aco-row aco-total" [class.invalid]="!isValid">
    <span class="aco-label">Total</span>
    <span class="aco-value">{{ totalLabel }}</span>
  </div>

  <p class="aco-error" *ngIf="!isValid">
    The check-out time must be after {{ start | date: 'HH:mm' }}.
  </p>

  <p class="aco-note">
    Recorded on {{ start | date: 'd MMM yyyy' }} as attendance — non-billable, and separate from
    the time you log against clients. Only whether you were at the office is stored, never your
    location itself.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!isValid" (click)="confirm()">
    Check out
  </button>
</mat-dialog-actions>
